<!-- @format -->

<div class="timesheet">
	@if (!isEditingEmployeeTimesheet) {
		<div class="calendar-scroll">
			<div class="buttonContainer top">
				<button class="previousMonthBtn" [class.disabled]="!getHasPreviousMonthEntry()" (click)="loadPreviousMonth()">
					<i class="fa-solid fa-circle-chevron-up"></i>
				</button>
			</div>
			<div class="calendarDisplay">
				<app-calendar
					[isYearView]="false"
					[calendarData]="extractMonthlyData(calendarOneMonth, calendarOneYear)"
					[isSelectedCalendarInstance]="isCalendarOneSelected"
					[filterToggleStates]="filterToggleStates"
					[selectedTimesheet]="selectedTimesheet"
					(selectedTimesheetEmitter)="handleWeekSelected($event, true)">
				</app-calendar>
				<app-calendar
					[isYearView]="false"
					[calendarData]="extractMonthlyData(calendarTwoMonth, calendarTwoYear)"
					[isSelectedCalendarInstance]="!isCalendarOneSelected"
					[filterToggleStates]="filterToggleStates"
					[selectedTimesheet]="selectedTimesheet"
					(selectedTimesheetEmitter)="handleWeekSelected($event, false)">
				</app-calendar>
			</div>
			<div class="buttonContainer bottom">
				<button class="nextMonthBtn" [class.disabled]="!getHasNextMonthEntry()" (click)="loadNextMonth()">
					<i class="fa-sharp fa-solid fa-circle-chevron-down"></i>
				</button>
			</div>
		</div>
	}

	@if (selectedTimesheet) {
		<div class="weekly-view">
			@if (isEditingEmployeeTimesheet) {
				<button (click)="activeModal.close()"><i class="fa-sharp fa-solid fa-xmark fa-2x"></i></button>
			}
			<div class="dateBar">
				<div class="current-week">
					<h1 class="selectedWeekDateRange">
						{{ generateWeekRangeString(selectedTimesheet) }}
						@if (editEmp) {
							<span>— {{empName}}</span>
						}
					</h1>
				</div>
				<div class="payPeriodWeek">{{payperiodWeek}}</div>
			</div>
			<h4>Review and submit your timesheet for this week.</h4>
			<div class="btns-container">
				<button (click)="viewHistory()" class="btn btn-link">History <i class="fa-regular fa-history"></i></button>
				@if (hasSubmittedTimesheet && toggleEdit && !isEditingEmployeeTimesheet) {
					<button (click)="editOverride(false)" class="btn btn-link">Edit <i class="fa-solid fa-pencil"></i></button>
				}
				@if (hasSubmittedTimesheet && !toggleEdit && !isEditingEmployeeTimesheet) {
					<button (click)="editOverride(true)" class="btn btn-link">Cancel <i class="fa-solid fa-times"></i></button>
				}
			</div>
			<app-entry-form
				[selectedTimesheet]="selectedTimesheet"
				[weekOneTsHasUsedCdo]="weekOneTsHasUsedCdo"
				[currentConfiguration]="currentConfiguration"
				[selectedPayPeriodTimesheets]="selectedPayPeriodTimesheets"
				[editOverride]="toggleEdit"
				[newEntryChanges]="newEditFormChanges"
				[addedRows]="addedRows"
				(openSidebar)="open(content)"
				(saveOrSubmitTimesheet)="saveOrSubmitTimesheet($event)"
				(openEditSidebar)="openEdit($event, content)"
				(hasSubmittedTimesheetData)="hasSubmittedTimesheetData($event)"
				[timeEntryTypes]="timeEntryTypes"
				[exceptionTypes]="exceptionTypes"
				[isEditingEmployeeTimesheet]="isEditingEmployeeTimesheet"
				[isTimesheetSubmitOnly]="canOnlySubmitTimesheet">
			</app-entry-form>
			<div class="microcopy privacyInformation">
				The District of North Vancouver uses this application to facilitate the submission, review, and management of employee time entry.
				Personal information you provide is used solely for this purpose and under the authority of the Freedom of Information and Protection
				of Privacy Act, Section 26 (c), (d). If you have questions about the use of your personal information, contact the Privacy Office at
				604-990-2211 or <a href="mailto:privacy@dnv.org">privacy&#64;dnv.org</a>.
			</div>
		</div>
	}
</div>

<ng-template #content let-offcanvas>
	<div class="offcanvas-header">
		<h4 class="offcanvas-title add-row-header" id="offcanvas-basic-title">
			@if (!isEdit) {
				<b>Add a row</b>
			}
			@if (isEdit) {
				<b>Edit a row</b>
			}
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="close()"><i class="fa-sharp fa-solid fa-xmark"></i></button>
	</div>

	<div class="offcanvas-body">
		<form [formGroup]="addRowForm" (ngSubmit)="isEdit ? editRow() : addRow()" #formDir="ngForm">
			<h5 class="row-property-title">Time Category</h5>
			<div class="add-row-select">
				<ng-select formControlName="type" (change)="resetSidebarOnTypeChange($event)" placeholder="Select one" bindLabel="entryText" dropdownPosition="bottom">
					@for (type of timeEntryTypes; track type.code) {
						@if (type.code === 'Time off' || type.code === 'Work time') {
							<ng-option [value]="type" [disabled]="true">
								<div class="timeCategoryGroupName">{{type.group}}</div>
							</ng-option>
						} @else {
							<ng-option [value]="type">
								<div class="label-wrapper d-flex">
									<div [style.background]="type.colour" class="entryType"></div>
									{{type.entryText}}
								</div>
							</ng-option>
						}
					}
				</ng-select>
			</div>

			@if (addRowForm.hasError('required','type') && formDir.submitted) {
				<div class="sidebar-error-msg">Make a selection.</div>
			}

			<!-- Overtime row questions -->
			@if (currentType === 'Overtime') {
				<div class="add-row-check">
					<div class="checkboxBtn">
						<label>
							<input type="checkbox" formControlName="isWorkOrderTime" (change)="updateWorkOrderControls()" />
							<span>Charge time to Work Order</span>
						</label>
					</div>
				</div>
				@if (this.addRowForm.value?.isWorkOrderTime) {
					<h5 class="row-property-title">
						<span>Work Order number</span>
						<a data-tool-tip="Enter the Work Order number e.g. 90006">
							<i class="fa-solid fa-circle-info"></i>
						</a>
					</h5>
					<input type="text" class="add-row-input-text-field" formControlName="workOrderNumber" />
					@if (addRowForm.hasError('required','workOrderNumber') && formDir.submitted) {
						<div class="sidebar-error-msg">Work order number is required</div>
					}

					@if (addRowForm.hasError('pattern', 'workOrderNumber') && formDir.submitted) {
						<div class="sidebar-error-msg">Work order number can only have numbers</div>
					}
					<h5 class="row-property-title">What did you work on during the overtime?</h5>
					<textarea class="row-notes" formControlName="workOrderDesc" maxlength="{{workOrderDescLimit}}"></textarea>
					@if (addRowForm.hasError('required','workOrderDesc') && formDir.submitted) {
						<div class="sidebar-error-msg">Description of the work undertaken is required</div>
					}
					<div class="microcopy">{{this.addRowForm.value?.workOrderDesc?.length || 0}}/{{workOrderDescLimit}}</div>
				} @else {
					<h5 class="row-property-title">
						<span>What did you work on during the overtime?</span>
					</h5>
					<input type="text" class="add-row-input-text-field" formControlName="natureOfWorkOT" [maxlength]="natureOfWorkTextLimit" />
					@if (addRowForm.hasError('required','natureOfWorkOT') && formDir.submitted) {
						<div class="sidebar-error-msg">Cannot be left blank</div>
					}
					<div class="microcopy">{{this.addRowForm.value?.natureOfWorkOT?.length || 0}}/{{natureOfWorkTextLimit}}</div>
				}
				<h5 class="row-property-title">
					<span>Was this overtime prescheduled?</span>
				</h5>
				<div class="add-row-select">
					@for (overtimePrescheduled of overtimePrescheduledDetails; track overtimePrescheduled) {
						<div class="radioBtn">
							<label>
								<input
									type="radio"
									formControlName="prescheduledOT"
									[value]="overtimePrescheduled.code"
									(change)="checkCallout($event)" />
								{{overtimePrescheduled.entryText}}
							</label>
						</div>
					}
				</div>
				@if (addRowForm.hasError('required','prescheduledOT') && formDir.submitted) {
					<div class="sidebar-error-msg">Make a selection</div>
				}
				@if (showWhenOtStartRadio) {
					<h5 class="row-property-title">
						<span>When did the overtime start?</span>
						<a data-tool-tip="We need this information to determine the pay rate for your overtime hours.">
							<i class="fa-solid fa-circle-info"></i>
						</a>
					</h5>
					<div class="add-row-select">
						@for (overTimeStartDetail of overTimeStartDetails; track overTimeStartDetail) {
							<div class="radioBtn">
								<label>
									<input type="radio" formControlName="adjacentOT" [value]="overTimeStartDetail.code" />
									{{overTimeStartDetail.entryText}}
								</label>
							</div>
						}
					</div>
					@if (addRowForm.hasError('required','adjacentOT') && formDir.submitted) {
						<div class="sidebar-error-msg">Make a selection</div>
					}
				}
				<h5 class="row-property-title">
					<span>What would you like to do with this time?</span>
				</h5>
				<div class="add-row-select">
					@for (overTimeStartDetail of bankOrPayoutOptions; track overTimeStartDetail) {
						<div class="radioBtn">
							<label>
								<input type="radio" formControlName="bankOrPayoutOT" [value]="overTimeStartDetail.code" />
								{{overTimeStartDetail.entryText}}
							</label>
						</div>
					}
				</div>
				@if (addRowForm.hasError('required','bankOrPayoutOT') && formDir.submitted) {
					<div class="sidebar-error-msg">Make a selection</div>
				}
			}

			@if (currentType === 'Sick') {
				<h5 class="row-property-title">Type of sick leave</h5>
				<div class="add-row-select">
					<ng-select formControlName="sickType" placeholder="Select one" [items]="sickTypeOptions" bindValue="code" bindLabel="entryText" dropdownPosition="bottom">
						<!-- <ng-select class="row-property-dropdown" formControlName="sickType" placeholder="Select one">
            <ng-option *ngFor="let type of sickTypeOptions()" [value]="type"><div class="label-wrapper d-flex">{{ type.entryText }}</div></ng-option> -->
					</ng-select>
				</div>
			}

			@if (addRowForm.hasError('required','sickType') && formDir.submitted) {
				<div class="sidebar-error-msg">Make a selection.</div>
			}

			@if (currentType === 'Other') {
				<h5 class="row-property-title">Type of leave</h5>
				<div class="add-row-select">
					<ng-select
						formControlName="leaveType"
						placeholder="Select one"
						[items]="otherLeaveOptions"
						bindValue="code"
						bindLabel="entryText" dropdownPosition="bottom">
						<!-- <ng-select class="row-property-dropdown" formControlName="leaveType" placeholder="Select one">
            <ng-option *ngFor="let type of otherLeaveOptions()" [value]="type"><div class="label-wrapper d-flex">{{ type.entryText }}</div></ng-option> -->
					</ng-select>
				</div>
			}
			@if (addRowForm.hasError('required','leaveType') && formDir.submitted) {
				<div class="sidebar-error-msg">Make a selection.</div>
			}

			@if (currentType === 'Banked') {
				<h5 class="row-property-title">Draw from bank</h5>
				<div class="add-row-select">
					<ng-select
						formControlName="bankedType"
						placeholder="Select one"
						[items]="bankedTypeOptions"
						bindValue="code"
						bindLabel="entryText" dropdownPosition="bottom">
						<!-- <ng-select class="row-property-dropdown" formControlName="leaveType" placeholder="Select one">
            <ng-option *ngFor="let type of otherLeaveOptions()" [value]="type"><div class="label-wrapper d-flex">{{ type.entryText }}</div></ng-option> -->
					</ng-select>
				</div>
			}
			@if (addRowForm.hasError('required','bankedType') && formDir.submitted) {
				<div class="sidebar-error-msg">Make a selection.</div>
			}

			@if (currentType === 'Union') {
				<h5 class="row-property-title">Union business</h5>
				<div class="add-row-select">
					<ng-select
						formControlName="unionBusinessType"
						placeholder="Select one"
						[items]="unionBusinessOptions"
						bindValue="code"
						bindLabel="entryText" dropdownPosition="bottom">
					</ng-select>
				</div>
			}
			@if (addRowForm.hasError('required','unionBusinessType') && formDir.submitted) {
				<div class="sidebar-error-msg">Make a selection.</div>
			}

			@if (getRowCanChargeToWorkOrder(currentType) && currentType !== 'Overtime') {
				<div class="add-row-check">
					<div class="checkboxBtn">
						<label>
							<input type="checkbox" formControlName="isWorkOrderTime" (change)="updateWorkOrderControls()" />
							<span>Charge time to Work Order</span>
						</label>
					</div>
				</div>
				@if (this.addRowForm.value?.isWorkOrderTime) {
					<h5 class="row-property-title">
						<span>Work Order number</span>
						<a data-tool-tip="Enter the Work Order number e.g. 90006">
							<i class="fa-solid fa-circle-info"></i>
						</a>
					</h5>
					<input type="text" class="add-row-input-text-field" formControlName="workOrderNumber" />
					@if (addRowForm.hasError('required','workOrderNumber') && formDir.submitted) {
						<div class="sidebar-error-msg">Work order number is required</div>
					}

					@if (addRowForm.hasError('pattern', 'workOrderNumber') && formDir.submitted) {
						<div class="sidebar-error-msg">Work order number can only have numbers</div>
					}
					<h5 class="row-property-title">Describe the work undertaken</h5>
					<textarea class="row-notes" formControlName="workOrderDesc" maxlength="{{workOrderDescLimit}}"></textarea>
					@if (addRowForm.hasError('required','workOrderDesc') && formDir.submitted) {
						<div class="sidebar-error-msg">Description of the work undertaken is required</div>
					}
					<div class="microcopy">{{this.addRowForm.value?.workOrderDesc?.length || 0}}/{{workOrderDescLimit}}</div>
				}
			}

			@if (currentType !== 'Overtime' && !this.addRowForm.value?.isWorkOrderTime) {
				<h5 class="row-property-title">
					Comments
					@if (currentType !== 'Training') {
						<span class="non-bolded-heading-text">(optional)</span>
					}
				</h5>
				<textarea class="row-notes" formControlName="comments" maxlength="{{commentsMaxLength}}"></textarea>
				@if (addRowForm.hasError('required','comments') && formDir.submitted) {
					<div class="sidebar-error-msg">Cannot be left blank</div>
				}
				<div class="microcopy">{{this.addRowForm.value?.comments?.length || 0}}/{{commentsMaxLength}}</div>
			}

			@if (!isEdit) {
				<button class="add-btn" type="submit">Add</button>
			}
			@if (isEdit) {
				<button class="add-btn" type="submit">Update</button>
			}
		</form>
	</div>
</ng-template>

<ng-template #bankCDODialog let-modal>
	<form [formGroup]="bankCDOForm" (ngSubmit)="bankCDOFormSubmit()" #formDir="ngForm">
		<div class="modal-body-non-center">
			@if (!toggleCdoDateSelectionPanel) {
				<h3 class="cdoModalHeading">
					<span><i class="fa-regular fa-calendar-xmark"></i></span>
					<b>Missing Compressed Day Off</b>
				</h3>
				<br />

				<p>Your timesheet indicates that you didn't take your scheduled CDO this week.</p>

				<p class="cdoOptionsBoldText">What would you like to do?</p>
				<div class="cdoOptionsRadioControl">
					<label>
						<input type="radio" value="payPeriod" formControlName="cdoUsageType" />
						<span>I&apos;ll take it on another day within this pay period</span>
					</label>

					<label>
						<input type="radio" value="banked" formControlName="cdoUsageType" />
						<span>Put it in the CDO Bank</span>
					</label>
				</div>

				@if (bankCDOForm.get("cdoUsageType")?.value === "payPeriod") {
					<p class="cdoOptionsBoldText">Select a date</p>
					<div class="cdoReschedulingSelectedDate" (click)="openDateSelectionPanel()">
						@if (selectedCdoReassignmentDate === null) {
							<span class="placeholderText">MM/DD/YYYY</span>
						} @else {
							<span>{{getFormattedCdoReassignmentDate()}}</span>
						}
					</div>
				} @else {
					<p class="cdoOptionsBoldText">When will you be using your banked CDO?<span class="asterisk_req"></span></p>

					<ng-select
						formControlName="bankType"
						placeholder="Select one"
						[items]="cdoBankOptions"
						bindValue="code"
						bindLabel="entryText" dropdownPosition="bottom"></ng-select>

					@if (bankCDOForm.hasError('required','bankType') && formDir.submitted) {
						<div class="sidebar-error-msg">Make a selection.</div>
					}

					@if (selectedBankType === 'Other') {
						<div class="otherBankTypeText">
							<textarea class="bankCDOOtherTypeText" formControlName="otherTypeText" maxLength="{{bankCDOTextLimit}}"></textarea>
							<p>{{bankCDOForm.controls.otherTypeText.value.length}}/{{bankCDOTextLimit}}</p>
							@if (bankCDOForm.hasError('required','otherTypeText') && formDir.submitted) {
								<div class="sidebar-error-msg">Cannot be left blank</div>
							}
						</div>
					}
				}

				<div class="buttonContainer">
					<button type="button" class="btn btn-submission-cancel" (click)="closeBankCDOModal(false)">Cancel</button>
					<button ngbAutofocus type="submit" class="btn btn-submission-bank">Confirm</button>
				</div>
			} @else {
				<h3 class="cdoDateSelectModalHeading">
					<span (click)="closeDateSelectionPanel()">
						<i class="fa-solid fa-arrow-left"></i>
					</span>

					<b>Select a date</b>
				</h3>
				<br />

				<p>Please select a date within the pay period.</p>

				<div class="cdoCalendarSelectorContainer">
					<div class="monthYear">{{getCdoCalendarMonthAndYear()}}</div>
					<div class="cdoCalendarContainer">
						<div class="calendar">
							<div class="calendarDays">
								<span>Sat</span>
								<span>Sun</span>
								<span>Mon</span>
								<span>Tue</span>
								<span>Wed</span>
								<span>Thu</span>
								<span>Fri</span>
							</div>

							<div class="calendarWeeks">
								@for (week of [].constructor(2); track $index; let currentWeek = $index) {
									<div class="weekRow">
										@for (day of [].constructor(7); track $index; let currentDay = $index) {
											<div
												class="weekDay"
												[class.disabled]="getWeekSelectionIsDisabled(currentWeek)"
												[class.selectedDate]="getIsSelectedCdoRescheduleDate(getDaysFromPayPeriodStart(currentWeek, currentDay))"
												(click)="setCdoRescheduleDate(currentWeek, currentDay)">
												<span class="dateDisplay">{{getCdoCalendarDateDisplayed(currentWeek, currentDay)}}</span>
												<div class="timesheetBarContainer">
													<div class="calendarBar" [style]="getCalendarBarStyles(currentWeek, currentDay)"></div>

													@if (getIsSavedOrPredictedData(currentWeek)) {
														<div class="calendarBar roundedBoarder unsubmittedMask"></div>
													}
												</div>
											</div>
										}
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			}
		</div>
	</form>
</ng-template>

<ng-template #timesheetHistoryModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">
			History for {{ generateWeekRangeString(selectedTimesheet) }} — {{empName || profile.user.firstName + ' ' + profile.user.lastName}}
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="closeHistoryModal()"><i class="fa-solid fa-times"></i></button>
	</div>
	<div class="modal-body history">
		@for (timesheet of timesheetHistory; track timesheet; let i = $index) {
			<div>
				<div class="timesheet-history-meta justify-content-start d-flex">
					<div class="timesheet-history-events">
						@if (!!timesheet.sendToJDEBy) {
							<div class="event">
								<div class="img">
									<img class="profile_icon" [src]="userImages[timesheet.sendToJDEBy] || null" />
								</div>
								<div class="timesheet-history-data-section">
									<div class="timesheet-history-timestamp">{{historyTime(timesheet.sendToJDEDateTime)}}</div>
									<div class="d-flex">
										<div class="status jde">
											<i class="fa-regular fa-circle-arrow-right"></i>
										</div>
										<span>Sent to JDE</span>
									</div>
								</div>
							</div>
						}
						@if (!!timesheet.approvedBy) {
							<div class="event">
								<div class="img">
									<img class="profile_icon" [src]="userImages[timesheet.approvedBy] || null" />
								</div>
								<div class="timesheet-history-data-section">
									<div class="timesheet-history-timestamp">{{historyTime(timesheet.approvedDateTime)}}</div>
									<div class="d-flex">
										<div class="status approved">
											<i class="fa-sharp fa-solid fa-circle-check"></i>
										</div>
										<span>{{ timesheet.approvedBy === "timesheet@dnv.org" ? "System approved" : "Timesheet approved" }}</span>
									</div>
								</div>
							</div>
						}
						@if (!!timesheet.submittedBy) {
							<div class="event">
								<div class="img">
									<img class="profile_icon" [src]="userImages[timesheet.submittedBy] || null" />
								</div>
								<div class="timesheet-history-data-section">
									<div class="timesheet-history-timestamp">{{historyTime(timesheet.submittedDateTime)}}</div>
									<div class="d-flex">
										<div class="status submitted">
											<i class="fa-regular fa-clock"></i>
										</div>
										<span>{{ submittedAndEditedBy(timesheet, i) }}</span>
									</div>
								</div>
							</div>
						}
						@if (!!timesheet.savedBy) {
							<div class="event">
								<div class="img">
									<img class="profile_icon" [src]="userImages[timesheet.savedBy] || null" />
								</div>
								<div class="timesheet-history-data-section">
									<div class="timesheet-history-timestamp">{{historyTime(timesheet.savedDateTime)}}</div>
									<div class="d-flex">
										<div class="status saved">
											<span class="fa-stack" style="vertical-align: top;">
												<i class="fa-regular fa-circle fa-stack-2x"></i>
												<i class="fa-sharp fa-solid fa-question fa-stack-1x"></i>
											</span>
										</div>
										<span>Saved</span>
									</div>
								</div>
							</div>
						}
					</div>
					<div
						class="timesheet-history-view d-flex"
						[class.align-items-center]="!!timesheet.approvedBy && !!timesheet.submittedBy"
						[class.align-items-start]="(!!timesheet.approvedBy && !timesheet.submittedBy) || (!timesheet.approvedBy && !!timesheet.submittedBy) || !!timesheet.savedBy"
						[class.jde]="!!timesheet.sendToJDEBy">
						<button
							class="btn btn-link collapsed"
							type="button"
							[class.active]="selectedHistoryTS.has(i)"
							(click)="toggleSection(i)"
							[attr.aria-expanded]="timesheet"
							[attr.aria-controls]="i">
							<i class="fa-solid fa-chevron-down"></i>
							<i class="fa-solid fa-chevron-up"></i>
						</button>
					</div>
				</div>
				<div id="{{i}}" [class.collapse]="!selectedHistoryTS.has(i)">
					<app-entry-form
						[selectedTimesheet]="timesheet"
						[timeEntryTypes]="timeEntryTypes"
						[isApprovalsView]="true"
						[currentConfiguration]="currentConfiguration"
						[exceptionTypes]="exceptionTypes">
					</app-entry-form>
					<hr />
				</div>
			</div>
		}

		@if (timesheetHistory.length === 0) {
			There is no history to display at this time.
		}
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-dark" (click)="closeHistoryModal()">Close</button>
	</div>
</ng-template>
